import React, { FC, useEffect } from 'react';
import { GoBackBtn } from '../header/GoBackBtn';
import { PageTitle } from '../../layout/core';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { fetchContactDetails } from '../../store/contacts/actions/contacts';
import { useContactsContext } from '../../store/contacts/contacts-context';
import { ContactInformation } from './ContactInformation';
import { ContactDetailsOrders } from './ContactDetailsOrders';
import { ContactDetailsPaymentMethods } from './ContactDetailsPaymentMethods';
import { ContactDetailsDetails } from './ContactDetailsDetails';
import { ContactDetailsInsights } from './ContactDetailsInsights';
import { Spinner } from '../Spinner';
import { useLocation } from 'react-router';
import { ROUTES } from '../../routing/routesEnums';

export const ContactDetails: FC = () => {
	const { t } = useTranslation();
	const { state } = useLocation();
	const { contactId } = useParams();
	const { contactsContextState: { isContactDetailsLoading }, dispatch } = useContactsContext();


	useEffect(() => {
		void fetchContactDetails(dispatch, contactId);
	}, []);

	if (isContactDetailsLoading) {
		return (
			<div className="card h-100">
				<div className="card-body">
					<Spinner pageLoader/>
				</div>
			</div>
		);
	}

	return (
		<>
			<PageTitle
				breadcrumbs={[
					{
						title: t('MENU.CONTACTS'),
						path: '/contacts',
						isSeparator: false,
						isActive: false
					},
					{
						title: '',
						path: '',
						isSeparator: true,
						isActive: false
					}
				]}
			>
				{contactId}
			</PageTitle>
			<div className="mb-5">
				<GoBackBtn path={`${ROUTES.CONTACTS}${state?.search ?? ''}`} />
			</div>
			<div className="row">
				<div className="col-12 col-md-4">
					<ContactInformation/>
					<ContactDetailsInsights/>
					<ContactDetailsDetails/>

				</div>
				<div className="col-12 col-md-8">
					<ContactDetailsOrders/>
					<ContactDetailsPaymentMethods/>
				</div>

			</div>
		</>
	);
};